import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../../AdminLayout";
import EmptyContent from "../../../Components/Empty-content/EmptyContent";
import ItemsLoader from "../../../Components/Loader/basic loader/ItemsLoader";
import TitleBar from "../../../Components/TitleBar";
import { useLoaderStore } from "../../../Store/Loader/LoaderStore";
import { useWeeklyReportsStore } from "../../../Store/ReportsStore/WeeklyReportsStore";
import Heading from "./components/Heading";
import Table from "./components/Table";

function WeeklyReports() {
  const { onReload, results, isLoading } = useWeeklyReportsStore();
  const { setLoader } = useLoaderStore();

  const pageLoad = useCallback(async () => {
    setLoader(true);
    await onReload();
    setLoader(false);
  }, []);

  useEffect(() => {
    pageLoad();
  }, []);

  const { t } = useTranslation();

  return (
    <AdminLayout>
      <TitleBar title={t("Haftalik tushum hisobotlari")} />
      <div className="container">
        <Heading />
        {isLoading ? (
          <ItemsLoader size={70} />
        ) : results?.length > 0 ? (
          <Table />
        ) : (
          <EmptyContent />
        )}
      </div>
    </AdminLayout>
  );
}

export default WeeklyReports;
